import { useContext } from 'react';
import { Typography, Table } from 'antd';
import locale from 'antd/es/locale/pt_BR';

import { ICongelamentosEmLoteExtrato } from '../../interfaces';

import { useAbaCongelamentosEmLote } from './useAbaCongelamentosEmLote';
import { GlobalContext } from '../../../../../../contexts/globalContext';

const { Text } = Typography;

interface IProps {
    congelamentos: ICongelamentosEmLoteExtrato[];
}

export function AbaCongelamentosEmLote({
    congelamentos,
}: IProps) {

    const {
        refContagemDoFiltro,
        columns,
    } = useAbaCongelamentosEmLote();

    const { theme } = useContext(GlobalContext);

    return (
        <Table
            className='marginTopTables'
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={congelamentos}
            scroll={{ x: 650 }}
            onChange={
                (pagination, filters, sorter, extra) => {
                    refContagemDoFiltro.current = extra.currentDataSource
                }
            }
            title={(registros) => {
                return (
                    <div
                        style={{
                            backgroundColor: theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                            padding: 10,
                            margin: -8,
                            marginBottom: 0.5
                        }}
                    >
                        <Text>
                            {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                congelamentos.length :
                                refContagemDoFiltro.current.length} num total de ${congelamentos.length} `}
                        </Text>
                    </div>
                )
            }}
            footer={(registros) => {
                return (
                    <div
                        style={{
                            textAlign: 'end'
                        }}
                    >
                        <Text>
                            {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                congelamentos.length :
                                refContagemDoFiltro.current.length} num total de ${congelamentos.length} `}
                        </Text>
                    </div>
                )
            }}
            size="small"
            pagination={{
                locale: { items_per_page: '' },
                showSizeChanger: false,
                defaultPageSize: 100,
                position: [],
                pageSizeOptions: ['10', '20', '50', '100']
            }}
            locale={locale.Table}
        />
    );
}
